import {useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';
import {getUserSession} from '@/helpers/userHelper';
import serverRoutesConst from '@/constants/serverRoutesConst';
import routesConst from '@/constants/routesConst';
import {PRIVACY_NOTICE_HTML} from './privacyNoticeHtml';
import './ClausesAcceptancePage.scss';

const WELCOME_MESSAGE = `<p>¡Bienvenido! Nos entusiasma acompañarte en esta etapa de tu desarrollo profesional. Sabemos que tu información personal es sumamente valiosa, por ello, agradecemos tu confianza al permitirnos realizar tu Ethics Socioeconomics & Background Check. Este proceso, solicitado por la empresa que te ha contactado, consiste en un estudio socioeconómico y una revisión de antecedentes que realizaremos de forma ética y transparente.</p>
<p>Ten la seguridad de que cada dato que nos proporciones será manejado con el más alto nivel de cuidado, confidencialidad y privacidad. Durante todo el proceso, nuestro equipo estará atento para resolver cualquier duda o requerimiento que tengas; no estás solo en este paso.</p>
<p>Para continuar en Ethics Data Analytics Platform, es indispensable que otorgues tu autorización aceptando la Declaración de Veracidad, así como tu conformidad con el Aviso de Privacidad y los Términos & Condiciones. Al ser un proceso de cumplimiento normativo, sin estas aceptaciones el estudio no podrá llevarse a cabo</p>`;

const TERMS_AND_CONDITIONS_HTML = `
<h2>I. OBJETO</h2>
<p>El presente contrato describe los términos y condiciones aplicables al uso del contenido, productos y/o servicios del sitio web Ethics Data Analytics del cual es titular Ethics Data Analytics. Para hacer uso del contenido, productos y/o servicios del sitio web el usuario deberá sujetarse a los presentes términos y condiciones.</p>
<p>El objeto es regular el acceso y utilización del contenido, productos y/o servicios a disposición del público en general en el dominio <a href="https://ethicsdataanalytics.com" target="_blank" rel="noreferrer">https://ethicsdataanalytics.com</a>.</p>
<p>El titular se reserva el derecho de realizar cualquier tipo de modificación en el sitio web en cualquier momento y sin previo aviso, el usuario acepta dichas modificaciones.</p>
<p>El acceso al sitio web por parte del usuario es libre y gratuito, la utilización del contenido, productos y/o servicios implica un costo de suscripción para el usuario.</p>
<p>El sitio web solo admite el acceso a personas mayores de edad y no se hace responsable por el incumplimiento de esto.</p>
<p>El sitio web está dirigido a usuarios residentes en México y cumple con la legislación establecida en dicho país, si el usuario reside en otro país y decide acceder al sitio web lo hará bajo su responsabilidad.</p>
<p>La administración del sitio web puede ejercerse por terceros, es decir, personas distintas al titular, sin afectar esto los presentes términos y condiciones.</p>
<h2>II. USUARIO</h2>
<p>La actividad del usuario en el sitio web como publicaciones o comentarios estarán sujetos a los presentes términos y condiciones. El usuario se compromete a utilizar el contenido, productos y/o servicios de forma lícita, sin faltar a la moral o al orden público, absteniéndose de realizar cualquier acto que afecte los derechos de terceros o el funcionamiento del sitio web.</p>
<p>El usuario se compromete a proporcionar información verídica en los formularios del sitio web.</p>
<p>El acceso al sitio web no supone una relación entre el usuario y el titular del sitio web.</p>
<p>El usuario manifiesta ser mayor de edad y contar con la capacidad jurídica de acatar los presentes términos y condiciones.</p>
<h2>III. ACCESO Y NAVEGACIÓN EN EL SITIO WEB</h2>
<p>El titular no garantiza la continuidad y disponibilidad del contenido, productos y/o servicios en el sitito web, realizará acciones que fomenten el buen funcionamiento de dicho sitio web sin responsabilidad alguna.</p>
<p>El titular no se responsabiliza de que el software esté libre de errores que puedan causar un daño al software y/o hardware del equipo del cual el usuario accede al sitio web. De igual forma, no se responsabiliza por los daños causados por el acceso y/o utilización del sitio web.</p>
<h2>IV. POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS</h2>
<p>Conforme a lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de Particulares, el titular se compromete a tomar las medidas necesarias que garanticen la seguridad del usuario, evitando que se haga uso indebido de los datos personales que el usuario proporcione en el sitio web.</p>
<p>El uso de datos personales se limitará a lo previsto en el Aviso de Privacidad disponible en <a href="https://ethicsdataanalytics.com/aviso_de_privacidad.html">https://www.ethicsdataanalytics.com/aviso-de-privacidad</a>.</p>
<p>Ethics Data Analytics se reserva el derecho de realizar cualquier tipo de modificación en el Aviso de Privacidad en cualquier momento y sin previo aviso, de acuerdo con sus necesidades o cambios en la legislación aplicable, el usuario acepta dichas modificaciones.</p>
<p>El sitio web implica la utilización de cookies que son pequeñas cantidades de información que se almacenan en el navegador utilizado por el usuario como datos de ingreso, preferencias del usuario, fecha y hora en que se accede al sitio web, sitios visitados y dirección IP, esta información es anónima y solo se utilizará para mejorar el sitio web. Las cookies facilitan la navegación y la hacen más amigable, sin embargo, el usuario puede desactivarlos en cualquier momento desde su navegador en el entendido de que esto puede afectar algunas funciones del sitio web.</p>
<h2>V. POLÍTICA DE ENLACES</h2>
<p>En el sitio web puede contener enlaces a otros sitios de internet pertenecientes a terceros de los cuales no se hace responsable.</p>
<h2>VI. POLÍTICA DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
<p>El titular manifiesta tener los derechos de propiedad intelectual e industrial del sitio web incluyendo imágenes, archivos de audio o video, logotipos, marcas, colores, estructuras, tipografías, diseños y demás elementos que lo distinguen, protegidos por la legislación mexicana e internacional en materia de propiedad intelectual e industrial.</p>
<p>El usuario se compromete a respetar los derechos de propiedad industrial e intelectual del titular pudiendo visualizar los elementos del sitio web, almacenarlos, copiarlos e imprimirlos exclusivamente para uso personal.</p>
<h2>VII. LEGISLACIÓN Y JURISDICCIÓN APLICABLE</h2>
<p>La relación entre el usuario y el titular se regirá por las legislaciones aplicables en México.</p>
<p>Ethics Data Analytics no se responsabiliza por la indebida utilización del contenido, productos y/o servicios del sitio web y del incumplimiento de los presentes términos y condiciones.</p>
`;

const STATEMENT_OF_TRUTH_TEXT = `Declaro que la información proporcionada es veraz y completa según mi conocimiento, 
sin alteraciones ni omisiones deliberadas. Ethics Data Analytics fundamenta su análisis en la buena fe que manifiesto; 
de identificarse datos falsos, acepto la cancelación, no aceptación o rechazo de mi proceso y las sanciones legales o 
corporativas que correspondan según la empresa solicitante`;

export default function ClausesAcceptancePage() {
  const [privacyNoticeAccepted, setPrivacyNoticeAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [statementOfTruthAccepted, setStatementOfTruthAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // mutate is used to refresh the user data after clauses are accepted
  const {mutate} = useOutletContext();

  const allAccepted = privacyNoticeAccepted && termsAccepted && statementOfTruthAccepted;

  const handleContinuar = async () => {
    if (!allAccepted || isSubmitting) return;
    setIsSubmitting(true);
    setError(null);

    try {
      const userSession = await getUserSession();
      const token = userSession?.accessToken?.jwtToken;

      const response = await fetch(`${serverRoutesConst.API}/clauses/accept`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error al aceptar las cláusulas (${response.status})`);
      }

      // Refresh user data so candidateRoot re-evaluates the flags
      if (mutate) {
        await mutate();
      }

      navigate(routesConst.candidateHome, {replace: true});
    } catch (err) {
      setError('Ocurrió un error al registrar tu aceptación. Por favor intenta de nuevo más tarde.');
      setIsSubmitting(false);
    }
  };

  return (
    <main className="container clauses-acceptance-page dashboard">
      <div className="row mb-4">
        <div className="name mb-5">Bienvenida</div>
        <div dangerouslySetInnerHTML={{__html: WELCOME_MESSAGE}} />
      </div>
      <div className="row mb-4">
        {/* Clause 1: Aviso de Privacidad */}
        <div className="name">Aviso de Privacidad</div>
        <div className="col-12 clause-card outlined-background mb-4">
          <div className="row clause-body privacy-notice-clause">
            <div dangerouslySetInnerHTML={{__html: PRIVACY_NOTICE_HTML}} />
          </div>
        </div>
        <div className="checkbox-group row pt-2">
          <div className="d-flex justify-content-start col-6 mb-2"
            key="privacy-notice-option">
            <input
              type="radio"
              className="form-check-input"
              id="privacy-notice-checkbox"
              checked={privacyNoticeAccepted}
              onChange={(e) => setPrivacyNoticeAccepted(e.target.checked)}
            />
            <label htmlFor="privacy-notice-checkbox"
              className="form-check-label">
                Aceptar
            </label>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        {/* Clause 2: Términos y Condiciones */}
        <div className="name">Términos y condiciones</div>
        <div className="col-12 clause-card outlined-background mb-4">
          <div className="row clause-body terms-conditions-clause">
            <div dangerouslySetInnerHTML={{__html: TERMS_AND_CONDITIONS_HTML}} />
          </div>
        </div>
        <div className="checkbox-group row pt-2">
          <div className="d-flex justify-content-start col-6 mb-2"
            key="terms-conditions-option">
            <input
              type="radio"
              className="form-check-input"
              id="terms-conditions-checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
            <label htmlFor="terms-conditions-checkbox"
              className="form-check-label">
                Aceptar
            </label>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        {/* Clause 3: Veracidad (Statement of Truth) */}
        <div className="name">Declaración de Veracidad</div>
        <div className="col-12 clause-card outlined-background mb-4">
          <div className="row clause-body statement-of-truth-clause">
            <p>{STATEMENT_OF_TRUTH_TEXT}</p>
          </div>
        </div>
        <div className="checkbox-group row pt-2">
          <div className="d-flex justify-content-start col-6 mb-2"
            key="statement-of-truth-option">
            <input
              type="radio"
              className="form-check-input"
              id="statement-of-truth-checkbox"
              checked={statementOfTruthAccepted}
              onChange={(e) => setStatementOfTruthAccepted(e.target.checked)}
            />
            <label htmlFor="statement-of-truth-checkbox"
              className="form-check-label">
                Aceptar
            </label>
          </div>
        </div>
      </div>

        {error && (
          <div className="alert alert-danger mt-3" role="alert">
            {error}
          </div>
        )}

        <div className="row mt-3">
          <div className="col-12">
            <div className="submit-button d-flex justify-content-center mt-3 save-controls">
              <button 
                className="btn btn-warning save"
                disabled={!allAccepted || isSubmitting}
                onClick={handleContinuar}>
                {isSubmitting ? 'Procesando...' : 'Continuar'}
              </button>
            </div>
          </div>
        </div>
    </main>
  );
}
